import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.settings');
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/ggeea/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-admin-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.settings/view.scss */
:host {
  display: block;
  height: 100%;
}

.admin-page {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.admin-settings {
  padding: 28px;
  gap: 18px;
  background: radial-gradient(circle at top left, rgba(16, 185, 129, 0.08), transparent 26%), linear-gradient(180deg, #fcfcfd 0%, #f8fafc 100%);
}

.admin-settings__hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.admin-settings__title {
  color: #111827;
  font-size: 24px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.admin-settings__subtitle {
  margin-top: 6px;
  color: #6b7280;
  font-size: 12px;
}

.admin-settings__tabs {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}

.admin-settings__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 14px;
  border-radius: 15px;
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.92);
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 10px 30px -28px rgba(15, 23, 42, 0.45);
  transition: transform 0.16s ease, border-color 0.16s ease, color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}

.admin-settings__tab:hover {
  transform: translateY(-1px);
  border-color: #a7f3d0;
  color: #047857;
  background: #f8fffb;
}

.admin-settings__tab.is-active {
  border-color: #10b981;
  background: linear-gradient(180deg, #ecfdf5 0%, #ffffff 100%);
  color: #047857;
  box-shadow: 0 22px 40px -34px rgba(5, 150, 105, 0.75);
}

.settings-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #e8edf2;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 24px 60px -48px rgba(15, 23, 42, 0.28);
}

.card--tight {
  padding: 18px;
}

.admin-settings table {
  border-collapse: separate;
  border-spacing: 0;
}

.admin-settings thead th {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.admin-settings tbody tr {
  transition: background 0.16s ease;
}

.admin-settings tbody tr:hover {
  background: #fbfcfd;
}

.admin-settings tbody td {
  vertical-align: middle;
}

.faq-settings {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.faq-settings__rail,
.faq-settings__content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.faq-settings__toolbar {
  flex-direction: row;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.faq-settings__toolbar-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-settings__toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.faq-settings__section-title {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.faq-settings__toolbar-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.faq-settings__toolbar-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 9px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.faq-settings__category-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-settings__category-sort-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-settings__category-row {
  display: block;
}

.faq-settings__category-card {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 34px;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  background: #fcfcfd;
}

.faq-settings__category-card.is-active {
  border-color: #a7f3d0;
  background: linear-gradient(180deg, #f6fffb 0%, #ffffff 100%);
}

.faq-settings__category-btn {
  width: 100%;
  padding: 10px 13px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.faq-settings__category-btn--card {
  padding: 0 2px;
  border: 0;
  background: transparent;
}

.faq-settings__category-btn--card:hover {
  border-color: transparent;
  background: transparent;
}

.faq-settings__category-btn:hover {
  border-color: #a7f3d0;
  background: #f8fffb;
}

.faq-settings__category-btn.is-active {
  border-color: #10b981;
  background: linear-gradient(180deg, #ecfdf5 0%, #ffffff 100%);
  box-shadow: 0 10px 24px -20px rgba(16, 185, 129, 0.8);
}

.faq-settings__category-name {
  color: #111827;
  font-size: 12px;
  font-weight: 600;
}

.faq-settings__category-order {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 12px;
  font-weight: 700;
  cursor: grab;
  user-select: none;
}

.faq-settings__category-order:active {
  cursor: grabbing;
}

.faq-settings__category-row--ghost .faq-settings__category-card {
  opacity: 0.45;
}

.faq-settings__category-row--chosen .faq-settings__category-card {
  border-color: #86efac;
  box-shadow: 0 16px 28px -24px rgba(15, 23, 42, 0.55);
}

.faq-settings__icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  background: #ffffff;
  color: #64748b;
}

.faq-settings__icon-btn.is-danger:hover {
  color: #e11d48;
  border-color: #fecdd3;
  background: #fff1f2;
}

.faq-settings__new-cat {
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
}

.faq-settings__new-cat-form {
  display: flex;
  gap: 8px;
}

.faq-settings__primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 13px;
  border-radius: 12px;
  background: #059669;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.faq-settings__primary-btn:hover {
  background: #047857;
}

.faq-settings__export-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 13px;
  border: 1px solid #a7f3d0;
  border-radius: 12px;
  background: #ecfdf5;
  color: #047857;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.faq-settings__export-btn:hover:not(:disabled) {
  border-color: #34d399;
  background: #d1fae5;
}

.faq-settings__export-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.faq-settings__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.faq-item-card {
  padding: 14px 15px;
  border: 1px solid #eceff3;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfd 100%);
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.faq-item-card:hover {
  border-color: #a7f3d0;
  background: #fbfffd;
}

.faq-item-card__top,
.faq-item-card__bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.faq-item-card__meta,
.faq-item-card__tags,
.faq-item-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.faq-item-card__badge,
.faq-item-card__tag,
.faq-item-card__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.faq-item-card__badge.is-category {
  background: #ecfdf5;
  color: #047857;
}

.faq-item-card__badge.is-sort {
  background: #eef2ff;
  color: #4338ca;
}

.faq-item-card__badge.is-muted {
  background: #f4f4f5;
  color: #71717a;
}

.faq-item-card__question {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.faq-item-card__answer {
  color: #52525b;
  font-size: 12px;
  line-height: 1.65;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.faq-item-card__tag {
  background: #f4f4f5;
  color: #52525b;
}

.faq-item-card__empty {
  color: #a1a1aa;
  font-size: 11px;
}

.faq-item-card__action {
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
}

.faq-item-card__action:hover {
  border-color: #a7f3d0;
  color: #047857;
}

.faq-item-card__action.is-danger:hover {
  border-color: #fecdd3;
  color: #e11d48;
}

.faq-settings__empty {
  padding: 28px 18px;
  border: 1px dashed #d4d4d8;
  border-radius: 18px;
  text-align: center;
  background: #fafafa;
}

.faq-settings__empty-title {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.faq-modal__field-help {
  margin-top: 5px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.6;
}

.rag-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-soft {
  background: linear-gradient(180deg, #fcfcfd 0%, #f8fafc 100%);
  border: 1px solid #eef2f7;
  border-radius: 18px;
  padding: 16px;
}

.rag-settings__toolbar-main {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rag-guide-card__copy,
.rag-settings__delete-copy,
.rag-settings__empty-copy {
  color: #64748b;
  font-size: 12px;
  line-height: 1.75;
}

.rag-settings__toolbar-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rag-settings__toolbar-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 9px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #4338ca;
  font-size: 11px;
  font-weight: 600;
}

.rag-settings__toolbar-chip.is-danger {
  background: #fee2e2;
  color: #b91c1c;
}

.rag-settings__toolbar-chip.is-search {
  background: #ecfdf5;
  color: #047857;
}

.rag-guide-card__title,
.rag-settings__delete-title,
.rag-settings__empty-title,
.rag-doc-card__title {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
}

.rag-settings__upload-trigger,
.rag-upload-modal__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 14px;
  border-radius: 12px;
  background: #059669;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
}

.rag-settings__upload-trigger:hover:not(:disabled),
.rag-upload-modal__button:hover {
  background: #047857;
}

.rag-settings__upload-trigger:disabled,
.rag-upload-modal__button.is-busy {
  opacity: 0.7;
  cursor: default;
}

.rag-settings__guide {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.rag-guide-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rag-guide-card__step {
  color: #059669;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.rag-settings__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rag-settings__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.rag-settings__search-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rag-settings__search-input {
  min-width: 0;
  flex: 1 1 auto;
}

.rag-settings__search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.rag-settings__search-btn.is-primary {
  border-color: #059669;
  background: #059669;
  color: #ffffff;
}

.rag-settings__search-btn:hover:not(:disabled) {
  border-color: #a1a1aa;
  background: #fafafa;
}

.rag-settings__search-btn.is-primary:hover:not(:disabled) {
  border-color: #047857;
  background: #047857;
}

.rag-settings__search-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.rag-upload-modal {
  width: 100%;
  max-width: 520px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.22);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rag-upload-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.rag-upload-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  color: #71717a;
}

.rag-upload-modal__close:hover:not(:disabled) {
  background: #f4f4f5;
  color: #111827;
}

.rag-upload-modal__copy,
.rag-upload-modal__hint {
  color: #64748b;
  font-size: 12px;
  line-height: 1.7;
}

.rag-upload-modal__fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.rag-settings__toolbar-meta,
.rag-doc-card__sub,
.rag-doc-card__meta-label,
.rag-settings__pager-label {
  color: #71717a;
  font-size: 11px;
}

.rag-docs {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rag-doc-card {
  border: 1px solid #edf2f7;
  border-radius: 18px;
  padding: 14px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rag-doc-card__top,
.rag-doc-card__actions {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.rag-doc-card__main {
  min-width: 0;
}

.rag-doc-card__title,
.rag-doc-card__sub {
  overflow-wrap: anywhere;
}

.rag-doc-card__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.rag-doc-card__status.is-ready {
  background: #dcfce7;
  color: #047857;
}

.rag-doc-card__status.is-indexing {
  background: #dbeafe;
  color: #1d4ed8;
}

.rag-doc-card__status.is-failed {
  background: #fee2e2;
  color: #b91c1c;
}

.rag-doc-card__status.is-archived {
  background: #f3f4f6;
  color: #6b7280;
}

.rag-doc-card__meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.rag-doc-card__meta-item {
  padding: 9px 11px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.rag-doc-card__meta-value {
  margin-top: 4px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.rag-doc-card__error {
  padding: 10px 12px;
  border-radius: 14px;
  background: #fff1f2;
  color: #be123c;
  font-size: 12px;
  line-height: 1.6;
}

.rag-doc-card__delete,
.rag-settings__pager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #fecdd3;
  background: #ffffff;
  color: #e11d48;
  font-size: 12px;
  font-weight: 600;
}

.rag-doc-card__delete:hover,
.rag-settings__pager-btn:hover:not(:disabled) {
  background: #fff1f2;
}

.rag-settings__pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.rag-settings__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.field-label {
  font-size: 12px;
  color: #475569;
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
}

.field-input {
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid #dbe1e8;
  border-radius: 12px;
  font-size: 13px;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.field-input:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);
}

.admin-settings button,
.admin-settings input,
.admin-settings select,
.admin-settings textarea {
  transition: all 0.15s ease;
}

.admin-settings textarea.field-input {
  min-height: 120px;
  padding-top: 10px;
}

@media (max-width: 1180px) {
  .admin-settings__tabs {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .faq-settings {
    grid-template-columns: 1fr;
  }
  .rag-settings__guide,
  .rag-doc-card__meta {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .admin-settings {
    padding: 20px;
  }
  .admin-settings__hero {
    align-items: flex-start;
    flex-direction: column;
  }
  .admin-settings__tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .faq-settings__toolbar,
  .faq-settings__toolbar-actions,
  .faq-item-card__top,
  .faq-item-card__bottom,
  .faq-settings__new-cat-form {
    flex-direction: column;
    align-items: stretch;
  }
  .rag-upload-modal__fields,
  .rag-doc-card__top,
  .rag-doc-card__actions,
  .rag-settings__toolbar {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: stretch;
  }
}`],
})
export class PageAdminSettingsComponent implements OnInit, OnDestroy {
    public tab: string = 'faq';
    public routerSub: any = null;
    public readonly tabs: Array<{ id: string; label: string; icon: string; }> = [
        { id: 'faq', label: 'FAQ', icon: 'fa-circle-question' },
        { id: 'rag', label: 'RAG 문서', icon: 'fa-file-lines' },
        { id: 'crawl', label: '데이터수집', icon: 'fa-database' },
        { id: 'banned', label: '금칙어', icon: 'fa-ban' },
        { id: 'llm', label: 'LLM', icon: 'fa-wand-magic-sparkles' },
        { id: 'users', label: '관리자', icon: 'fa-user-shield' },
    ];

    // LLM settings
    public settings: any = {};

    // FAQ
    public faqCats: any[] = [];
    public faqItems: any[] = [];
    public faqSelectedCat: string | null = null;
    public newCatName: string = '';
    public faqCatSortOptions: any = {
        animation: 150,
        handle: '.faq-settings__category-order',
        ghostClass: 'faq-settings__category-row--ghost',
        chosenClass: 'faq-settings__category-row--chosen',
        onUpdate: () => this.persistFaqCategoryOrder(),
    };
    public editingItem: any = null;
    public faqExporting: boolean = false;

    // Banned
    public bannedWords: any[] = [];
    public newBannedPattern: string = '';
    public newBannedIsRegex: boolean = false;
    public newBannedMessage: string = '';

    // RAG
    public ragDocs: any[] = [];
    public ragTotal: number = 0;
    public ragPage: number = 1;
    public ragKeyword: string = '';
    public ragKeywordApplied: string = '';
    public ragUploadTopic: string = '';
    public ragUploadTitle: string = '';
    public ragUploadModalOpen: boolean = false;

    // Crawl
    public crawlSources: any[] = [];
    public newCrawl: any = { name: '', root_url: '', enabled: true };

    // Users
    public users: any[] = [];
    public newUser: any = { email: '', password: '', name: '', role: 'admin' };

    public busy: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        await this.updateTab();
        this.routerSub = this.router.events.subscribe(async (e) => {
            if (e instanceof NavigationEnd) await this.updateTab();
        });
        await this.loadTab();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async updateTab() {
        const requested = String(WizRoute?.segment?.tab || 'faq');
        const t = this.tabs.some((item) => item.id === requested) ? requested : 'faq';
        if (requested !== t) {
            this.service.href(`/admin/settings/${t}`);
            return;
        }
        if (t !== this.tab) {
            this.tab = t;
            await this.service.render();
            await this.loadTab();
        }
    }

    public goTab(t: string) {
        this.service.href(`/admin/settings/${t}`);
    }

    public async loadTab() {
        try {
            if (this.tab === 'llm') await this.loadSettings();
            else if (this.tab === 'faq') await this.loadFaq();
            else if (this.tab === 'banned') await this.loadBanned();
            else if (this.tab === 'rag') await this.loadRag();
            else if (this.tab === 'crawl') await this.loadCrawl();
            else if (this.tab === 'users') await this.loadUsers();
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
        await this.service.render();
    }

    // ======== LLM ========
    public async loadSettings() {
        this.settings = await this.service.api('settings', 'all');
    }
    public async saveSetting(key: string) {
        await this.service.api('settings', 'set', { key, value: this.settings[key] || '' });
        this.service.alert('저장되었습니다.');
    }
    public isLlmSelected(provider: string, model: string): boolean {
        const curProvider = this.settings['llm.provider'] || 'openai';
        if (curProvider !== provider) return false;
        const modelKey = provider === 'gemini' ? 'llm.model.gemini' : 'llm.model.openai';
        return (this.settings[modelKey] || '') === model;
    }
    public async selectLlmModel(provider: string, model: string) {
        this.settings['llm.provider'] = provider;
        const modelKey = provider === 'gemini' ? 'llm.model.gemini' : 'llm.model.openai';
        this.settings[modelKey] = model;
        await this.service.render();
        try {
            await this.service.api('settings', 'set', { key: 'llm.provider', value: provider });
            await this.service.api('settings', 'set', { key: modelKey, value: model });
            this.service.alert(`선택되었습니다: ${provider} / ${model}`);
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
    }

    // ======== FAQ ========
    public async loadFaq() {
        this.faqCats = await this.service.api('faq', 'categories');
        this.faqItems = await this.service.api('faq', 'items', this.faqSelectedCat ? { category_id: this.faqSelectedCat } : {});
    }
    public async selectFaqCat(cid: string | null) {
        this.faqSelectedCat = cid;
        await this.loadFaq();
        await this.service.render();
    }
    private nextFaqCategorySort(): number {
        let maxSort = 0;
        for (const category of this.faqCats) {
            const sort = Number(category?.sort || 0);
            if (sort > maxSort) maxSort = sort;
        }
        return maxSort + 1;
    }
    public async addCat() {
        if (!this.newCatName.trim()) return;
        await this.service.api('faq', 'create_cat', { name: this.newCatName, sort: this.nextFaqCategorySort() });
        this.newCatName = '';
        await this.loadFaq();
        await this.service.render();
    }
    public async persistFaqCategoryOrder() {
        try {
            for (let index = 0; index < this.faqCats.length; index++) {
                const category = this.faqCats[index];
                category.sort = index + 1;
                await this.service.api('faq', 'update_cat', { id: category.id, name: category.name, sort: category.sort });
            }
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
        await this.loadFaq();
        await this.service.render();
    }
    public async deleteCat(c: any) {
        if (!this.service.confirm(`카테고리 "${c.name}" 삭제? (소속 FAQ 항목도 함께 삭제)`)) return;
        await this.service.api('faq', 'delete_cat', { id: c.id });
        await this.loadFaq();
        await this.service.render();
    }
    public faqCategoryName(categoryId: string | null | undefined): string {
        const id = String(categoryId || '');
        if (!id) return '미분류';
        const found = this.faqCats.find((category) => category?.id === id);
        return found?.name || id;
    }
    private faqTagText(tag: any): string {
        if (tag === null || tag === undefined) return '';
        if (typeof tag === 'string' || typeof tag === 'number') return String(tag).trim();
        if (typeof tag === 'object') {
            return String(tag.label || tag.name || tag.value || tag.text || '').trim();
        }
        return '';
    }
    public faqTagList(item: any): string[] {
        const raw = item?.tags;
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw.map((tag) => this.faqTagText(tag)).filter(Boolean);
        }
        if (typeof raw === 'string') {
            const text = raw.trim();
            if (!text) return [];
            if ((text.startsWith('[') && text.endsWith(']')) || (text.startsWith('{') && text.endsWith('}'))) {
                try {
                    return this.faqTagList({ tags: JSON.parse(text) });
                } catch (e) { }
            }
            return text.split(',').map((tag) => tag.trim()).filter(Boolean);
        }
        return [this.faqTagText(raw)].filter(Boolean);
    }
    public faqFilterLabel(): string {
        if (!this.faqSelectedCat) return '전체 카테고리';
        return this.faqCategoryName(this.faqSelectedCat);
    }
    public faqActiveCount(): number {
        return this.faqItems.filter((item) => !!item?.active).length;
    }
    public async exportFaqXlsx() {
        if (this.faqExporting) return;
        this.faqExporting = true;
        await this.service.render();
        try {
            const form = new FormData();
            if (this.faqSelectedCat) form.append('category_id', this.faqSelectedCat);
            const response = await fetch('/api/ggeea/admin/faq/export_xlsx', {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            if (!response.ok) {
                let message = 'FAQ 엑셀 파일을 생성하지 못했습니다.';
                try {
                    const error = await response.json();
                    message = error?.message || error?.data?.message || message;
                } catch (e) { }
                throw new Error(message);
            }
            const disposition = response.headers.get('Content-Disposition') || '';
            const filenameMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : 'FAQ.xlsx';
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (e: any) {
            this.service.alert(e?.message || String(e));
        } finally {
            this.faqExporting = false;
            await this.service.render();
        }
    }
    public async closeEditItem() {
        this.editingItem = null;
        await this.service.render();
    }
    public async startEditItem(i: any | null) {
        this.editingItem = i ? { ...i, active: !!i.active } : { id: null, category_id: this.faqSelectedCat || (this.faqCats[0]?.id || ''), question: '', answer: '', tags: '', sort: 0, active: true };
        await this.service.render();
    }
    public async saveItem() {
        if (!this.editingItem) return;
        const e = this.editingItem;
        if (!e.category_id || !e.question || !e.answer) {
            this.service.alert('카테고리, 질문, 답변을 입력해 주세요.');
            return;
        }
        const payload: any = {
            category_id: e.category_id,
            question: e.question,
            answer: e.answer,
            tags: e.tags || '',
            sort: e.sort || 0,
            active: e.active ? 1 : 0,
        };
        if (e.id) {
            payload.id = e.id;
            await this.service.api('faq', 'update', payload);
        } else {
            await this.service.api('faq', 'create', payload);
        }
        this.editingItem = null;
        await this.loadFaq();
        await this.service.render();
    }
    public async deleteItem(i: any) {
        if (!this.service.confirm(`"${i.question}" 삭제?`)) return;
        await this.service.api('faq', 'delete', { id: i.id });
        await this.loadFaq();
        await this.service.render();
    }

    // ======== Banned ========
    public async loadBanned() {
        this.bannedWords = await this.service.api('banned', 'list');
    }
    public async addBanned() {
        if (!this.newBannedPattern.trim()) return;
        await this.service.api('banned', 'create', {
            pattern: this.newBannedPattern,
            is_regex: this.newBannedIsRegex ? 1 : 0,
            message: this.newBannedMessage || '',
        });
        this.newBannedPattern = '';
        this.newBannedMessage = '';
        this.newBannedIsRegex = false;
        await this.loadBanned();
        await this.service.render();
    }
    public async toggleBanned(b: any) {
        await this.service.api('banned', 'update', { id: b.id, active: b.active ? 0 : 1 });
        await this.loadBanned();
        await this.service.render();
    }
    public async deleteBanned(b: any) {
        if (!this.service.confirm('삭제하시겠습니까?')) return;
        await this.service.api('banned', 'delete', { id: b.id });
        await this.loadBanned();
        await this.service.render();
    }

    // ======== RAG ========
    public async loadRag() {
        const pageSize = 20;
        const keyword = String(this.ragKeywordApplied || '').trim();
        if (keyword) {
            const res = await this.service.api('rag', 'list', { page: 1, dump: 1000000, keyword });
            const allItems = res.items || [];
            const start = (this.ragPage - 1) * pageSize;
            this.ragDocs = allItems.slice(start, start + pageSize);
            this.ragTotal = allItems.length;
            return;
        }
        const params: any = { page: this.ragPage, dump: pageSize };
        const res = await this.service.api('rag', 'list', params);
        this.ragDocs = res.items || [];
        this.ragTotal = res.total || 0;
    }
    public async searchRag() {
        this.ragKeywordApplied = String(this.ragKeyword || '').trim();
        this.ragPage = 1;
        await this.loadRag();
        await this.service.render();
    }
    public async clearRagSearch() {
        if (!this.ragKeyword && !this.ragKeywordApplied) return;
        this.ragKeyword = '';
        this.ragKeywordApplied = '';
        this.ragPage = 1;
        await this.loadRag();
        await this.service.render();
    }
    public ragStatusLabel(status: string): string {
        const value = String(status || 'pending');
        if (value === 'ready') return '준비 완료';
        if (value === 'indexing') return '인덱싱 중';
        if (value === 'failed') return '실패';
        if (value === 'archived') return '보관됨';
        return '대기 중';
    }
    public ragSourceLabel(doc: any): string {
        const sourceType = String(doc?.source_type || '').toLowerCase();
        if (sourceType === 'pdf') return '업로드 PDF';
        if (sourceType === 'file') return '파일 문서';
        if (sourceType === 'crawl') return '크롤링 문서';
        if (sourceType === 'html') return '웹 문서';
        return sourceType || '문서';
    }
    public ragPageReadyCount(): number {
        return this.ragDocs.filter((doc) => doc?.status === 'ready').length;
    }
    public ragPageFailedCount(): number {
        return this.ragDocs.filter((doc) => doc?.status === 'failed').length;
    }
    public ragHasSearch(): boolean {
        return !!String(this.ragKeywordApplied || '').trim();
    }
    public formatBytes(value: any): string {
        const bytes = Number(value || 0);
        if (!bytes) return '-';
        if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
        if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
        return `${bytes} B`;
    }
    public async openRagUploadModal() {
        this.ragUploadModalOpen = true;
        await this.service.render();
    }
    public async closeRagUploadModal() {
        if (this.busy) return;
        this.ragUploadModalOpen = false;
        await this.service.render();
    }
    public async uploadRag(ev: Event) {
        const el = ev.target as HTMLInputElement;
        if (!el.files || !el.files.length) return;
        this.busy = true;
        await this.service.render();
        const form = new FormData();
        for (let i = 0; i < el.files.length; i++) form.append('files', el.files[i]);
        if (this.ragUploadTopic) form.append('topic_key', this.ragUploadTopic);
        if (this.ragUploadTitle) form.append('title', this.ragUploadTitle);
        try {
            const res = await fetch('/api/ggeea/admin/rag/upload', { method: 'POST', body: form, credentials: 'include' });
            const body = await res.json();
            const code = typeof body?.code === 'number' ? body.code : res.status;
            if (code !== 200) throw new Error(body.message || '업로드 실패');
            this.service.alert('업로드 및 인덱싱 완료');
            this.ragUploadTopic = '';
            this.ragUploadTitle = '';
            this.ragUploadModalOpen = false;
            await this.loadRag();
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
        this.busy = false;
        el.value = '';
        await this.service.render();
    }
    public async deleteRag(d: any) {
        if (!this.service.confirm(`"${d.title}" 삭제?\n\n이 문서의 파일, 청크 메타, Milvus 벡터가 함께 삭제되어 이후 RAG 검색 근거에서는 제외됩니다.\n다만 모델이 원래 알고 있거나 다른 문서에도 같은 내용이 있으면 답변은 계속 나올 수 있습니다.`)) return;
        await this.service.api('rag', 'delete', { id: d.id });
        await this.loadRag();
        await this.service.render();
    }

    // ======== Crawl ========
    public async loadCrawl() {
        this.crawlSources = await this.service.api('crawl', 'list');
    }
    public async addCrawl() {
        if (!this.newCrawl.name || !this.newCrawl.root_url) {
            this.service.alert('이름과 시작 URL을 입력해 주세요.');
            return;
        }
        await this.service.api('crawl', 'create', {
            name: this.newCrawl.name,
            root_url: this.newCrawl.root_url,
            host: '',
            include_patterns: JSON.stringify([]),
            exclude_patterns: JSON.stringify([]),
            enabled: this.newCrawl.enabled ? 1 : 0,
        });
        this.newCrawl = { name: '', root_url: '', enabled: true };
        await this.loadCrawl();
        await this.service.render();
    }
    public async runCrawl(c: any) {
        if (!this.service.confirm(`"${c.name}" 크롤링을 지금 실행할까요? (시간이 걸릴 수 있습니다)`)) return;
        this.busy = true;
        await this.service.render();
        try {
            const res = await this.service.api('crawl', 'run', { id: c.id });
            this.service.alert(`완료: 방문 ${res.visited || 0}페이지, 파일 ${res.files || 0}개`);
            await this.loadCrawl();
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
        this.busy = false;
        await this.service.render();
    }
    public async toggleCrawl(c: any) {
        await this.service.api('crawl', 'update', { id: c.id, enabled: c.enabled ? 0 : 1 });
        await this.loadCrawl();
        await this.service.render();
    }
    public async deleteCrawl(c: any) {
        if (!this.service.confirm(`"${c.name}" 삭제?`)) return;
        await this.service.api('crawl', 'delete', { id: c.id });
        await this.loadCrawl();
        await this.service.render();
    }

    // ======== Users ========
    public async loadUsers() {
        this.users = await this.service.api('users', 'list');
    }
    public async addUser() {
        if (!this.newUser.email || !this.newUser.password) {
            this.service.alert('이메일과 비밀번호는 필수입니다.');
            return;
        }
        if (!this.service.confirm(`관리자 "${this.newUser.email}" 계정을 추가하시겠습니까?`)) return;
        try {
            await this.service.api('users', 'create', this.newUser);
            this.newUser = { email: '', password: '', name: '', role: 'admin' };
            await this.loadUsers();
            await this.service.render();
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
    }
    public async changePassword(u: any) {
        const pw = prompt(`"${u.email}" 의 새 비밀번호`);
        if (!pw) return;
        await this.service.api('users', 'password', { id: u.id, password: pw });
        this.service.alert('비밀번호가 변경되었습니다.');
    }
    public async deleteUser(u: any) {
        if (!this.service.confirm(`관리자 "${u.email}" 계정을 삭제하시겠습니까?`)) return;
        try {
            await this.service.api('users', 'delete', { id: u.id });
            await this.loadUsers();
            await this.service.render();
        } catch (e: any) {
            this.service.alert(e.message || String(e));
        }
    }

    public ragMaxPage(): number { return Math.max(1, Math.ceil(this.ragTotal / 20)); }
    public async ragGoPage(p: number) {
        if (p < 1 || p > this.ragMaxPage()) return;
        this.ragPage = p;
        await this.loadRag();
        await this.service.render();
    }
}

export default PageAdminSettingsComponent;